import React, { useMemo } from "react";
import { cn } from "../../../lib/utils";

export interface AvatarProps {
  name: string;
  className?: string;
}

const getInitials = (name: string) => {
  const cleaned = name.trim();
  if (!cleaned) return "";
  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] ?? ""}${parts[parts.length - 1][0] ?? ""}`.toUpperCase();
};

export const Avatar: React.FC<AvatarProps> = ({ name, className }) => {
  const initials = useMemo(() => getInitials(name), [name]);

  return (
    <div
      className={cn(
        "w-10 h-10 rounded-full bg-[#F5F5F5] flex items-center justify-center shrink-0",
        className,
      )}
      aria-label={name}
      title={name}
    >
      <span className="font-sans font-normal text-sm leading-5 text-center text-[#0A0A0A]">
        {initials}
      </span>
    </div>
  );
};

export default Avatar;
